import { jsx as r, Fragment as l, jsxs as m } from "react/jsx-runtime";
import b, { forwardRef as v, Children as h, cloneElement as x } from "react";
import { S as y } from "./index-B_6_jmOO.js";
import { c as L } from "./index-CYpVUGdk.js";
import { $ as t } from "./utils-CTvPli9r.js";
import { L as f } from "./loader-circle-CXsMazZi.js";
const g = L(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), N = v(
  ({ className: o, variant: i, size: a, asChild: p = !1, loading: n, children: e, ...s }, d) => p ? /* @__PURE__ */ r(y, { ref: d, ...s, children: /* @__PURE__ */ r(l, { children: h.map(e, (c) => {
    if (!b.isValidElement(c)) return null;
    const u = c;
    return x(u, {
      className: t(g({ variant: i, size: a }), o),
      children: /* @__PURE__ */ m(l, { children: [
        n && /* @__PURE__ */ r(f, { className: t("h-4 w-4 animate-spin", e && "mr-2") }),
        u.props.children
      ] })
    });
  }) }) }) : /* @__PURE__ */ m(
    "button",
    {
      className: t(g({ variant: i, size: a, className: o })),
      disabled: n,
      ref: d,
      ...s,
      children: [
        n && /* @__PURE__ */ r(f, { className: t("h-4 w-4 animate-spin", e && "mr-2") }),
        e
      ]
    }
  )
);
N.displayName = "LoadingButton";
export {
  N as LoadingButton
};
//# sourceMappingURL=loading-button.js.map
